// Clan Wars — team-based weekly gem-contribution board.
// Client caches the player's current clan (id + name + tag) after any
// /api/clan/me success so the menu button can show a compact badge.

const CACHE_KEY = "ppe_clan_v1";

export function getCachedClan() {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (!d || !d.clan_id) return null;
    return d;
  } catch {
    return null;
  }
}

export function setCachedClan(clan) {
  if (!clan || !clan.clan_id) {
    localStorage.removeItem(CACHE_KEY);
    return;
  }
  localStorage.setItem(
    CACHE_KEY,
    JSON.stringify({
      clan_id: clan.clan_id,
      name: clan.name || "",
      tag: clan.tag || "",
    })
  );
}

export function clearCachedClan() {
  localStorage.removeItem(CACHE_KEY);
}
